import * as React from 'react'
import { IconButton, Badge } from '@applift/factor'
import { GridIconSlotsComponent } from '../../models/gridIconSlotsComponent'
import { ReactTableSortDirection } from '../../models/gridReactTable'
import { useGridRootProps } from '../../hooks/utils/useGridRootProps'
import { GridIconButtonContainer } from './GridIconButtonContainer'
import style from '../../style/index.module.scss'

export interface GridColumnHeaderSortIconProps {
  direction: false | ReactTableSortDirection
  index: number | undefined
  firstSortDir: ReactTableSortDirection
  showBadge: boolean
}

function getIcon(
  icons: GridIconSlotsComponent,
  direction: false | ReactTableSortDirection,
  firstSortDir: ReactTableSortDirection,
  className?: string
) {
  let Icon
  const iconProps: any = {}
  if (direction === 'asc') {
    Icon = icons.ColumnSortedAscendingIcon
  } else if (direction === 'desc') {
    Icon = icons.ColumnSortedDescendingIcon
  } else {
    Icon = icons.ColumnUnsortedIcon
    // iconProps.firstSortDir = firstSortDir
  }
  return Icon ? (
    <Icon fontSize={16} className={className ?? ''} {...iconProps} />
  ) : null
}

function GridColumnHeaderSortIconRaw(props: GridColumnHeaderSortIconProps) {
  const { direction, index, firstSortDir, showBadge } = props
  const rootProps = useGridRootProps()
  const iconElement = getIcon(rootProps.components, direction, firstSortDir)
  if (!iconElement) {
    return null
  }

  const iconButton = (
    <IconButton
      tabIndex={-1}
      classes={{ root: style.headerIconBtn }}
      color="secondary"
      disableFocusRipple
    >
      {iconElement}
    </IconButton>
  )

  return (
    <GridIconButtonContainer>
      {showBadge && (index ?? -1) >= 0 ? (
        <Badge badgeContent={(index ?? 0) + 1} color="warning">
          {iconButton}
        </Badge>
      ) : (
        iconButton
      )}
    </GridIconButtonContainer>
  )
}

export const GridColumnHeaderSortIcon = React.memo(GridColumnHeaderSortIconRaw)
